import { render, staticRenderFns } from "./error-layout.vue?vue&type=template&id=74e8cf8b"
import script from "./error-layout.vue?vue&type=script&lang=js"
export * from "./error-layout.vue?vue&type=script&lang=js"
import style0 from "./error-layout.vue?vue&type=style&index=0&id=74e8cf8b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports